exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result-msg[data-v-77501d2e]{padding:1rem;text-align:center}.result-msg-img[data-v-77501d2e]{width:2.4rem;height:2.4rem;margin:0 auto .4rem}.result-msg-img img[data-v-77501d2e]{width:100%;height:100%}.result-info[data-v-77501d2e]{font-size:.32rem;line-height:1.8;color:#999}.result-info button[data-v-77501d2e]{margin-top:.4rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77501d2e","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/basic/result.msg.vue
// module id = iJzL
// module chunks = 29